import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=19ba29ea&scoped=true&"
import script from "./setup.vue?vue&type=script&lang=js&"
export * from "./setup.vue?vue&type=script&lang=js&"
import style0 from "./setup.vue?vue&type=style&index=0&id=19ba29ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba29ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ba29ea')) {
      api.createRecord('19ba29ea', component.options)
    } else {
      api.reload('19ba29ea', component.options)
    }
    module.hot.accept("./setup.vue?vue&type=template&id=19ba29ea&scoped=true&", function () {
      api.rerender('19ba29ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/modules/setup.vue"
export default component.exports